<script setup>
import { computed } from 'vue'
import { whatsappLink, formatPhone, trackConversion } from '@/lib/whatsapp'
import { trackQuoteCtaClick } from '@/lib/analytics'

const props = defineProps({
  phone: { type: String, required: true }
})

const readablePhone = computed(() => formatPhone(props.phone))
const href = computed(() => whatsappLink(props.phone))
const year = new Date().getFullYear()

const links = [
  { href: '#productos', label: 'Cortinas' },
  { href: '#telas', label: 'Telas y terminaciones' },
  { href: '#servicios', label: 'Servicios' },
  { href: '#medir', label: 'Cómo medir' },
  { href: '#proceso', label: 'Cómo trabajamos' },
  { href: '#cotizar', label: 'Pedir cotización' }
]
</script>

<template>
  <footer class="bg-night">
    <div class="mx-auto max-w-7xl px-6 pb-28 pt-12 lg:px-10 lg:pb-16 lg:pt-16">
      <div class="grid gap-10 sm:grid-cols-2 lg:grid-cols-12">
        <div class="lg:col-span-5">
          <div class="flex items-center gap-3">
            <img
              src="/lumina-isologo.png"
              alt=""
              class="h-10 w-auto"
              width="182"
              height="160"
            >
            <p class="display text-3xl text-linen">Casa Lumina</p>
          </div>
          <p class="mt-3 max-w-xs leading-relaxed text-linen/65">
            Cortinas roller, verticales y persianas a medida. Cotizamos,
            fabricamos e instalamos.
          </p>
        </div>

        <nav class="lg:col-span-3 lg:col-start-7" aria-label="Pie de página">
          <h2 class="eyebrow text-linen/55">Secciones</h2>
          <ul class="mt-3">
            <li v-for="link in links" :key="link.href">
              <a
                :href="link.href"
                class="block py-3 text-sm text-linen/75 transition-colors hover:text-glow"
              >
                {{ link.label }}
              </a>
            </li>
          </ul>
        </nav>

        <div class="lg:col-span-3">
          <h2 class="eyebrow text-linen/55">Contacto</h2>
          <a
            :href="href"
            target="_blank"
            rel="noopener"
            class="display mt-3 block py-1.5 text-2xl text-glow transition-colors hover:text-linen"
            @click="trackConversion('footer', 'cortinas a medida')"
          >
            {{ readablePhone }}
          </a>
          <p class="mt-2 text-sm text-linen/60">
            Cotiza por WhatsApp o
            <a
              href="#cotizar"
              class="font-semibold text-linen/80 underline decoration-linen/25 underline-offset-4 transition-colors hover:text-glow hover:decoration-glow"
              @click="trackQuoteCtaClick('footer')"
            >con el formulario</a>: te llega por correo.
          </p>
        </div>
      </div>

      <div class="mt-12 flex flex-wrap items-baseline gap-x-6 gap-y-2 border-t border-linen/10 pt-6 text-sm text-linen/55">
        <p>
          © {{ year }} Casa Lumina. Los precios se entregan por cotización, según
          medida, tela y sistema.
        </p>
        <!-- El formulario pide dirección y teléfono: quién quiera saber qué pasa
             con eso tiene que encontrar la respuesta sin buscarla. -->
        <a
          href="/privacidad"
          class="text-linen/75 underline decoration-linen/25 underline-offset-4 transition-colors hover:text-glow hover:decoration-glow"
        >
          Política de privacidad
        </a>
      </div>
    </div>
  </footer>
</template>
